<template>
  <el-dialog :visible.sync="open_modal" title="服务项目" class="order_box" :closable="false" width="600">
    <div class="divBox" style="padding: 0 0 20px 0">
      <el-row type="flex" class="mb10">
        <el-input placeholder="请输入项目名称" v-model="thisForm.keyword" class="input-with-select">
          <el-button slot="append" icon="el-icon-search" @click="searchs"></el-button>
        </el-input>
      </el-row>
      <el-table border :data="list" v-loading="loading" size="small">
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column prop="title" label="项目名称"></el-table-column>
        <el-table-column label="是否开通">
          <template slot-scope="{ row, index }">
            <el-switch
              v-model="row.isOpen"
              @change="onChangeOpen(row.id)"
            />
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          background
          :page-size="thisForm.limit"
          :current-page="thisForm.page"
          :total="total"
          :page-sizes="[20, 40, 60, 80]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="pageChange"
        />
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {getServiceItemList, createStaffRelate, getSetUpList} from '@/api/technician';

export default {
  name: 'serviceItem',
  data() {
    return {
      open_modal: false,
      list: [],
      loading: false,
      thisForm: {
        page: 1,
        limit: 20,
        staffId: 0,
        keyword: '',
        type: 1
      },
      total: 0,
    }
  },
  mounted() {
  },
  methods: {
    // 获取门店服务项目
    getList() {
      this.loading = true;
      getSetUpList(this.thisForm).then((data) => {
        this.list = data.data.list;
        this.total = data.data.total;
        this.loading = false;
      }).catch((err) => {
        this.loading = false;
        this.$message.err(err.msg);
      })
    },
    // 开通或关闭
    onChangeOpen(item_id) {
      let param = {
        itemId: item_id,
        staffId: this.thisForm.staffId,
      };
      createStaffRelate(param).then(async (res) => {
        this.$message.success('提交成功');
      }).catch((res) => {
        this.$message.error(res.msg);
      });
    },
    // 分页
    pageChange(index) {
      this.thisForm.page = index;
      this.getList();
    },
    handleSizeChange(val) {
      this.thisForm.limit = val;
      this.getList();
    },
    // 搜索
    searchs() {
      this.thisForm.page = 1;
      this.getList();
    },

  },
}
</script>

<style>

</style>
